<template>
  <div class="e-asset-card" :key="asset.id">
    <div class="e-asset-card__header">
      <div class="e-asset-card__header--left">
        <div class="e-asset-card__text eh-primary-text">{{ asset.name | shortText(10) }}</div>
      </div>

      <div class="e-asset-card__header--right" v-if="!showDescribe">
        <hr class="e-divider e-divider--direction--vertical"/>
        <div class="e-asset-card__text eh-secondary-text">{{ asset.symbol }}</div>
        <div class="e-asset-card__info" @click="toggleDescribe"></div>
      </div>
    </div>
      <transition name="fade" mode="out-in">
        <div key="face" v-if="!showDescribe">
          <div class="e-asset-card__content">
            <router-link :to="{name:'asset', params: {id: asset.id}}" class="e-asset-card__logo">
              <img :src="asset.logoPath" width="100%" height="100%"/>
            </router-link>
            <div class="e-asset-card__meta">
              <div class="e-asset-card__meta-col">
                <b-btn ref="popoverBtn" class="e-btn e-btn--outlined e-btn--color--gray-dark e-btn--size--small d-sm-flex d-xl-none">Learn More</b-btn>
                <b-popover class="e-popover" :target="() => this.$refs.popoverBtn" placement="top" triggers="hover focus">
                  <ul class="ee-list eh-secondary-text">
                    <li><p class="mr-2">Assets Vol:</p><p class="ml-auto">{{ asset.volume }} USD ($)</p></li>
                    <li><p class="mr-2">Forecasted:</p><p class="ml-auto">{{ asset.totalForecasters }} <span class="e-asset-card__forecasted-icon"></span></p></li>
                    <li><p class="mr-2">Added in portfolio:</p><p class="ml-auto">{{ asset.totalInPortfolio }}</p></li>
                  </ul>
                </b-popover>
              </div>
              <div class="e-asset-card__meta-col">
                <div v-if="asset.change24" class="badge e-badge e-asset-card__trend e-badge--size--large" :class="asset.change24 >= 0 ? ' e-asset-card__trend--up' : ' e-asset-card__trend--down'">
                  {{ asset.change24 >= 0 ? '+' : '-' }} {{ asset.change24.toFixed(2) }} %
                  <span class="e-asset-card__trend-icon"></span>
                </div>
              </div>
            </div>
            <!-- <p class="e-asset-card__forecast" :class="forecastPrediction(7) >= 0 ? 'e-asset-card__forecast--up' : 'e-asset-card__forecast--down'">
              Forecast: {{ forecastPrediction(7) >= 0 ? '+' : '-' }} {{ Math.abs(forecastPrediction(7)).toFixed(2) }}%
            </p> -->
            <div class="e-asset-card__info">
              <div class="e-asset-card__price">{{ asset.price.value ? `${this.formatPrice(asset.price.value)} ${asset.price.currency}` : 'N/A' }}</div>
              <div class="e-asset-card__rate">{{ asset.rate === 0 ? 'N/A' : asset.rate }}</div>
            </div>
          </div>
          <ul class="e-asset-card__list ee-list eh-secondary-text d-none d-xl-flex">
            <li><p class="mr-2">Assets Vol:</p><p class="ml-auto">{{ asset.volume }} USD ($)</p></li>
            <li><p class="mr-2">Forecasted:</p><p class="ml-auto">{{ asset.totalForecasters }} <span class="e-asset-card__forecasted-icon"></span></p></li>
            <li><p class="mr-2">Added in portfolio:</p><p class="ml-auto">{{ asset.totalInPortfolio }}</p></li>
          </ul>
        </div>
        <div key="back" class="e-asset-card__describe eh-primary-text" v-if="showDescribe">
          <p>{{ asset.description | shortText(240) }}</p>
          <b-btn class="e-btn e-btn--outlined e-btn--color--gray-dark e-btn--size--small px-3" @click="toggleDescribe">Back</b-btn>
        </div>
      </transition>
  </div>
</template>

<script>
  import _ from 'lodash';

	export default {
		name: "e-asset-card",
    props: {
      asset: {
        type: Object,
        required: true,
      }
    },
    filters: {
      shortText(value, len) {
		    if(value.length > len) {
          value = value.substring(0, len - 3) + '...'
        }

        return value
      },
      formatPrice(price) {
        price = parseFloat(price);
        if(price <= 10) {
          return price.toFixed(6);
        } else if(price <= 50) {
          return price.toFixed(4);          
        }

        return price.toFixed(2)        
      },
    },
    computed: {
    },
    data() {
		  return {
        showDescribe: false,
      }
    },
    methods: {
      toggleDescribe() {
        this.showDescribe = !this.showDescribe;
      },
      formatPrice(price) {
        price = parseFloat(price);
        if(price <= 10) {
          return price.toFixed(4);
        } else if(price <= 50) {
          return price.toFixed(3);          
        }

        return price.toFixed(2)        
      },
      forecastPrediction(period) {
        // return this.asset.forecastPredictions.find(p => p.period === period).value / this.asset.price.value * 100 - 100
        return 4.85;
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/assetCard/assetCard.vue